export type TClientVariant = "A" | "B";

const getStoredVariant = (key: string): TClientVariant | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const v = window.sessionStorage.getItem(key);
    return v === "A" || v === "B" ? v : null;
  } catch {
    return null;
  }
};

const setStoredVariant = (key: string, value: TClientVariant): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // ignore storage errors
  }
};

export const assignClientVariant = (storageKey: string, percentForB: number): TClientVariant => {
  const sticky = getStoredVariant(storageKey);
  if (sticky) {
    return sticky;
  }

  const roll = Math.random() * 100;
  const assigned: TClientVariant = roll < percentForB ? "B" : "A";

  setStoredVariant(storageKey, assigned);
  return assigned;
};
